import { CreatePasswordResetRequest, CreatePasswordResetResponse } from './protos/password_reset_pb';
import { createRequestString, getResponseBytes, http, isHttpError } from 'services/base/http';
import { ResultKind } from 'services/base/types';

export type CreateResult =
  | { kind: ResultKind.OK }
  | { kind: ResultKind.SYSTEM_ERROR }
  | {
    kind: ResultKind.USER_ERROR;
    emailError?: string;
  };

export const post = async(email: string): Promise<CreateResult> => {
  try {
    const request = createCreatePasswordResetRequest(email);
    await http.post('/start-password-reset/', createRequestString(request));
    return { kind: ResultKind.OK };
  } catch (error) {
    if (isHttpError(error)) {
      if (error.response?.status && error.response.status < 500) {
        const httpResp = error.response;
        const response = CreatePasswordResetResponse.deserializeBinary(getResponseBytes(httpResp));
        return {
          kind: ResultKind.USER_ERROR,
          emailError: response.getEmailError(),
        };
      }
    }
    return { kind: ResultKind.SYSTEM_ERROR };
  }
};

function createCreatePasswordResetRequest(email: string): CreatePasswordResetRequest {
  const request = new CreatePasswordResetRequest();
  request.setEmail(email);
  return request;
}
